var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content",style:(_vm.styleObj)},_vm._l((200),function(item,index){return _c('div',{key:index,staticClass:"snow"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }